import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import PropositoPage from "@/pages/PropositoPage";
import SobrePage from "@/pages/SobrePage";
import ServicosPage from "@/pages/ServicosPage";
import ProdutosPage from "@/pages/ProdutosPage";
import LojaPage from "@/pages/LojaPage";
import DepoimentosPage from "@/pages/DepoimentosPage";
import ContatoPage from "@/pages/ContatoPage";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/proposito" element={<PropositoPage />} />
            <Route path="/sobre" element={<SobrePage />} />
            <Route path="/servicos" element={<ServicosPage />} />
            <Route path="/produtos" element={<ProdutosPage />} />
            <Route path="/loja" element={<LojaPage />} />
            <Route path="/depoimentos" element={<DepoimentosPage />} />
            <Route path="/contato" element={<ContatoPage />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
